<template>
  <v-flex 
    :class="classBenefitItem" 
    @click="goToShowBenefit" 
    pointer
    >
    <v-flex text-xs-center style="position: relative;">
      <v-img :src="benefit.image" :style="widthImg">
        <v-flex :class="classTextCard">
          {{ benefit.name }}
        </v-flex>
      </v-img>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: {
    benefit: {
      type: Object,
      required: true
    }
  },
  computed: {
    widthImg() {
      if (this.$vuetify.breakpoint.smAndDown) {
        let sizeCard = this.isMobileXs() ? "130px" : "170px"
        return `height: ${sizeCard}; width: ${sizeCard}; object-fit: cover; margin-left: 5px`;
      } else {
        return 'height: 284px; width: 284px; object-fit: cover;';
      }
    },
    classBenefitItem() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'xs6 pb-2';
      } else {
        return 'xs12 sm4 pl-3 pr-3 pb-3';
      }
    },
    classTextCard() {
      if (this.$vuetify.breakpoint.smAndDown) {
        let sizeText = this.isMobileXs() ? "text-10-security" : "text-12-security"
        return `${sizeText} white--text font-weight-bold text-card-security background-card-security text-xs-center`
      } else {
        return "text-17-security white--text font-weight-bold text-card-security background-card-security text-xs-center"
      }
    },
  },
  methods: {
    goToShowBenefit() {
      this.$router.push({
        name: "benefit-show",
        params: { id: this.benefit.id }
      });
    },
    isMobileXs() {
      return window.innerWidth <= 320
    }
  }
};
</script>

<style>
.text-card-security {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 50%;
  padding-top: 30%;
  transform: translate(-50%);
}
.background-card-security{
  height: 50%;
  background: linear-gradient(to top,#000, transparent);
}
</style>
